app.controller("SessionExpireWindowController", ["$scope", "$uibModalInstance", "params", "$interval",
    function ($scope, $uibModalInstance, params, $interval) {
        $scope.sessionTime = 10;

        var timer;

        timer = $interval(function () {
            $scope.sessionTime--;
            if ($scope.sessionTime == 0) {
                $interval.cancel(timer);
                timer = null;
                $scope.close({ logout: true });
            }
        }, 1000);

        $scope.close = function (data) {
            $interval.cancel(timer);
            timer = null;
            $uibModalInstance.close(data);
        };
    }
]);
